module.exports = __webpack_public_path__ + "img/fw_bg.644ebdbc.jpg";